import httpClient from '../services/httpClient';
import apiMail from '../services/apiMail';

export default {
  httpClient,
  apiMail,
};
